<div mat-dialog-title style="padding: 10px; color: #FFF; background-color:#1579ab;">
  <div class="d-flex justify-content-between">
      Workflow History |
      {{dciToWorkflowHistory.doc_Title ? dciToWorkflowHistory.doc_Title : dciToWorkflowHistory.documentTitle}}
      ( {{dciToWorkflowHistory.doc_No ? dciToWorkflowHistory.doc_No:dciToWorkflowHistory.documentNumber}} )
      <i class="fa fa-times-circle pull-right" style="font-size: 24px;" (click)="closeDialog()" aria-hidden="true"></i>
  </div>
</div>
<div mat-dialog-content>
  <div class="row m-0">
      <div class="col-12 p-0">
          <div [ngClass]="{'kgrid-fullscreen' : enableFullscreen }">
              <kendo-grid [kendoGridBinding]="getworkflowHistoryvalue" [reorderable]="true" [sortable]="true" [resizable]="true" [filterable]="enableFilter" [pageSize]="15" [pageable]="true" [scrollable]="true" [height]="560">
                  <ng-template kendoPagerTemplate>
                      <div class="k-pager-left">
                          <kendo-pager-info></kendo-pager-info>
                      </div>
                      <div class="k-pager-right">
                          <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
                          <kendo-pager-input></kendo-pager-input>
                          <kendo-pager-next-buttons></kendo-pager-next-buttons>
                      </div>
                  </ng-template>
                  <ng-template kendoGridToolbarTemplate>
                      <div class="k-grid-toolbar-content d-flex">
                          <div class="flex-grow-1 mat-panel-headerbar"></div>
                          <div class="pagination-container">
                              <div class="icons-container">
                                  <div *ngIf="FromDeleteDocument" class="pagination-container"><span class="eip-mr-15"></span>
                                      <input style="width: 100px;" type="number" placeholder="Step Id." [(ngModel)]="SerialNo">
                                      <i class="fa fa-trash icon-my-10" title="Delete Step" aria-hidden="true" (click)="DeleteOrUpdateWorkflow('Delete')"></i>
                                      <div class="divider-container"><span></span></div>
                                      <i class="fas fa-edit icon-my-10" title="Update Step" (click)="DeleteOrUpdateWorkflow('Update')" aria-hidden="true"></i>
                                  </div>
                              </div>
                          </div>
                          <div class="divider-container d-none d-md-block" id="imgDivider">
                              <span></span>
                          </div>
                          <div class="pagination-container">
                              <p id="lblShowDetails">Show</p>
                              <kendo-pager-page-sizes [pageSizes]="[15, 30, 50, 100, {text: 'All',value: 'all'}]" id="ddlRecordsperPage">of
                              </kendo-pager-page-sizes>
                              <span>Items</span>
                          </div>
                          <div class="divider-container d-none d-md-block" id="imgDivider">
                              <span></span>
                          </div>
                          <div class="icons-container">
                              <i class="fa fa-ellipsis-v d-block d-md-none" aria-hidden="true" [ngClass]="{'ellipsis-active' : toggleListIcons}" (click)="toggleListIcons = !toggleListIcons"></i>
                              <div class="d-none d-md-flex align-items-md-center" [ngClass]="{'icons-list-type' : toggleListIcons}">
                                  <div class="icon-wrap" (click)="toggleFullscreen()">
                                      <i class="fa " [ngClass]="enableFullscreen ? 'fa-compress': ' fa-expand'" aria-hidden="true" title="{{ !enableFullscreen ? 'Expand' : 'Collapse' }}"></i>
                                      <span class="list-icon-name">{{ !enableFullscreen ? 'Expand' : 'Collapse' }}</span>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </ng-template>
                  <kendo-grid-column title="Step Id" filterable="false" width="70">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        {{dataItem.taskSerialNumber}}
                    </ng-template>
                </kendo-grid-column>
                  <kendo-grid-column width="50">
                      <ng-template kendoGridHeaderTemplate let-column let-columnIndex="columnIndex" title="Files">
                          <i aria-hidden="true" title="All Attachment" class="fa fa-paperclip fs-16 eip-mr-5" style="font-size: 15px; cursor: pointer; margin-left: 2%;" (click)="viewAttachmentClick()"></i>
                      </ng-template>
                      <ng-template kendoGridCellTemplate let-rowIndex="rowIndex" let-dataItem="dataItem">
                          <i aria-hidden="true" *ngIf="dataItem.isFileAvailable || dataItem.integration_Type == 'DTN Preparation'" title="Step Wise Attachment" class="fa fa-paperclip fs-16 eip-mr-5 eip-link" (click)="viewstepAttachmentClick(dataItem)"></i>
                      </ng-template>
                  </kendo-grid-column>                 
                  <kendo-grid-column title="Revision No" filterable="false" width="100">
                      <ng-template kendoGridCellTemplate let-dataItem>
                        <span class="no-wrap" eipTooltip="{{dataItem.revisionNumber}}" eipTooltipPosition="auto" style=" display: block;word-wrap:break-word;white-space: normal;">
                            {{dataItem.revisionNumber}}
                        </span>
                      </ng-template>
                  </kendo-grid-column>
                  <kendo-grid-column title="Workflow" filterable="false" width="150">
                      <ng-template kendoGridCellTemplate let-dataItem>
                          <span class="no-wrap" eipTooltip="{{getWorkflowName(dataItem.workflowId)}}" eipTooltipPosition="auto" style=" display: block;word-wrap:break-word;white-space: normal;">
                              {{getWorkflowName(dataItem.workflowId)}}
                          </span>
                      </ng-template>
                  </kendo-grid-column>                 
                  <kendo-grid-column title="Workflow Task" filterable="false" width="300">
                      <ng-template kendoGridCellTemplate let-dataItem>
                          <span class="no-wrap" eipTooltip="{{dataItem.taskName}}" eipTooltipPosition="auto" style=" display: block;word-wrap:break-word;white-space: normal;">
                              {{dataItem.taskName}}
                          </span>
                      </ng-template>
                  </kendo-grid-column>
                  <kendo-grid-column title="Task Integration Type" filterable="false" width="150">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <span class="no-wrap" eipTooltip="{{dataItem.integration_Type}}" eipTooltipPosition="auto" style=" display: block;word-wrap:break-word;white-space: normal;">
                            {{dataItem.integration_Type}}
                        </span>
                    </ng-template>
                </kendo-grid-column>
                  <kendo-grid-column title="Action Performed" filterable="false" width="150">
                      <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                          <div class="no-wrap" eipTooltip="{{dataItem.actionPerformedName}}" eipTooltipPosition="auto">
                              <ng-container *ngFor="let value of dataItem.actionPerformedDisplayName; let i = index">
                                  <ng-container *ngIf="value == 'Pending'">
                                      <span style="color:red">{{value}}</span>
                                  </ng-container>
                                  <ng-container *ngIf="value != 'Pending'">
                                      <span *ngIf="((i + 1) < dataItem.actionPerformedDisplayName.length)" style="margin-right: 5px;">{{value}},</span>
                                      <span *ngIf="((i + 1) == dataItem.actionPerformedDisplayName.length)" style="margin-right: 5px;">{{value}}</span>
                                  </ng-container>
                              </ng-container>
                          </div>
                      </ng-template>
                  </kendo-grid-column>                 
                  <kendo-grid-column title="Assigned On" filterable="false" width="100">
                      <ng-template kendoGridCellTemplate let-dataItem>
                          <span class="no-wrap" eipTooltip="{{dataItem.assignedOn}}" eipTooltipPosition="auto" style=" display: block;word-wrap:break-word;white-space: normal;">
                              {{dataItem.assignedOn}}
                          </span>
                      </ng-template>
                  </kendo-grid-column>
                  <kendo-grid-column title="Assigned To" filterable="false" width="150">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <span class="no-wrap" eipTooltip="{{dataItem.assignedToName}}" eipTooltipPosition="auto" style=" display: block;word-wrap:break-word;white-space: normal;">
                            {{dataItem.assignedToName}}
                        </span>
                    </ng-template>
                </kendo-grid-column>
                  <kendo-grid-column title="Hold" filterable="false" width="80">
                      <ng-template kendoGridCellTemplate let-dataItem>
                          <div *ngIf="dataItem.is_On_Hold == '1'; else not">
                              Yes
                          </div>
                      </ng-template>
                      <ng-template #not>
                          No
                      </ng-template>
                  </kendo-grid-column>
                  <kendo-grid-column title="Hold On" field="holded_On" filterable="false" width="100">
                      <ng-template kendoGridCellTemplate let-dataItem>
                          <span class="no-wrap" eipTooltip="{{dataItem.holded_On}}" eipTooltipPosition="auto" style=" display: block;word-wrap:break-word;white-space: normal;">
                              {{dataItem.holded_On}}
                          </span>
                      </ng-template>
                  </kendo-grid-column>
                  <kendo-grid-column title="Reason For Hold" field="reason_for_Hold" filterable="false" width="150">
                      <ng-template kendoGridCellTemplate let-dataItem>
                          <span class="no-wrap" eipTooltip="{{dataItem.reason_for_Hold}}" eipTooltipPosition="auto" style=" display: block;word-wrap:break-word;white-space: normal;">
                              {{dataItem.reason_for_Hold}}
                          </span>
                      </ng-template>
                  </kendo-grid-column>
                  <kendo-grid-column title="Completed On" filterable="false" width="100">
                      <ng-template kendoGridCellTemplate let-dataItem>
                          <span class="no-wrap" eipTooltip="{{dataItem.completedOn}}" eipTooltipPosition="auto" style=" display: block;word-wrap:break-word;white-space: normal;">
                              {{dataItem.completedOn}}
                          </span>
                      </ng-template>
                  </kendo-grid-column>
                  <kendo-grid-column title="Completed By" filterable="false" width="150">
                      <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                          <span class="no-wrap" eipTooltip="{{dataItem.completedByName}}" eipTooltipPosition="auto" style=" display: block;word-wrap:break-word;white-space: normal;">
                              {{dataItem.completedByName}}
                          </span>
                      </ng-template>
                  </kendo-grid-column>
                  <kendo-grid-column title="Status" filterable="false" width="150" hidden="true">
                      <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                          <span class="no-wrap" eipTooltip="{{dataItem.documentCurrentStatusName}}" eipTooltipPosition="auto" style=" display: block;word-wrap:break-word;white-space: normal;">
                              {{dataItem.documentCurrentStatusName}}
                          </span>
                      </ng-template>
                  </kendo-grid-column>
                  <kendo-grid-column title="Transmittal" filterable="false" width="150">
                    <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                        <span class="no-wrap" eipTooltip="{{dataItem.comment_Sheet_No}}" eipTooltipPosition="auto" style=" display: block;word-wrap:break-word;white-space: normal;">
                            {{dataItem.comment_Sheet_No}}
                        </span>
                    </ng-template>
                </kendo-grid-column>
                  <kendo-grid-column title="Comments" filterable="false" width="150">
                      <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                          <span class="no-wrap" eipTooltip="{{dataItem.comments}}" eipTooltipPosition="auto" style=" display: block;word-wrap:break-word;white-space: normal;">
                              {{dataItem.comments}}
                          </span>
                      </ng-template>
                  </kendo-grid-column>
                  <kendo-grid-column title="Delay Reason (Internal / External)" filterable="false" width="150">
                      <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                          <span class="no-wrap" eipTooltip="{{dataItem.delayReason}}" eipTooltipPosition="auto" style=" display: block;word-wrap:break-word;white-space: normal;">
                              {{dataItem.delayReason}}
                          </span>
                      </ng-template>
                  </kendo-grid-column>
              </kendo-grid>
          </div>
      </div>
  </div>
</div>